<template lang="pug">
.banner-wrapper
    VRow.banner-wrapper-inner.banner-content
        VCol.text-section(:variants="['xs-12', 'lg-5']")
            .text-wrapper
                .sub-heading
                    span.line
                    h2 Multidisciplinary design & production studio
                .title
                    img(src="@/assets/logo-text.svg")
                .description
                    p
                        | Our creative visionaries bring your ideas to life through meticulously designed websites, mobile apps and professional film productions.
                a.primary-button(@click="goToAbout", data-cursor-shrink) Who are we?
        VCol.service-images(
            :variants="['xs-12', 'xs-first', 'lg-7', 'lg-last']"
        )
            .service-images-wrapper(ref="parallax")
                .layer-gridlines(data-depth="0.05")
                    img(src="@/assets/banner/Layer-Lines.png")
                .layer-graphics(data-depth="0.1")
                    img(src="@/assets/banner/Layer-Graphics.png")
                .layer-images(data-depth="0.25")
                    img(src="@/assets/banner/Layer-Photos.png")
                .layer-labels(data-depth="0.45")
                    img(src="@/assets/banner/Layer-Labels-BG.png")
                .layer-labels-text(data-depth="0.45")
                    img(src="@/assets/banner/Layer-Labels-FG.png")
</template>
<script>
import Parallax from "parallax-js";
import { EventBus } from "@/events/global-bus.js";
//import ServiceGallery from "./service-gallery.js";
export default {
    name: "home-banner",
    mounted() {
        //new ServiceGallery(this.$refs.parallaxInject);
        new Parallax(this.$refs.parallax, {
            relativeInput: true,
            calibrateX: true,
            calibrateY: true,
        });
    },
    methods: {
        goToAbout() {
            EventBus.$emit("scrollAbout");
        },
    },
};
</script>

<style lang="scss">
.banner-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    position: relative;
    // height: 100vh;
    height: 100%;
    background-color: $cl-cream;
    box-sizing: border-box;
    padding: 0 $body-padding-desktop-x;

    @include respond-below(md) {
        padding: $body-padding-mobile-y $body-padding-mobile-x;
        padding-top: 9.6rem;
    }

    .banner-wrapper-inner {
        flex-grow: 0;
        flex-shrink: 0;
        width: 100%;

        &.banner-content {
            flex-grow: 1;
        }
    }

    .banner-content {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 0 $body-padding-desktop-x;
        height: 100%;

        @include respond-below(lg) {
            padding: 0;
            position: relative;
            // display: unset;
            align-items: flex-start;
            height: auto;

            .text-wrapper {
                max-width: 100%;
                margin-left: 0;
            }
        }

        .text-section {
            // width: 40%;
            position: relative;
            z-index: 99;
            // display: flex;
            // justify-content: flex-end;

            .text-wrapper {
                max-width: 70%;
                margin-left: 11.2rem;
            }

            .sub-heading {
                display: flex;
                width: 100%;
                align-items: center;

                h2 {
                    font-size: 1.8rem;
                    font-weight: 600;
                }

                .line {
                    flex-grow: 1;
                    background-color: $cl-grey;
                    height: 1px;
                    margin-right: 2rem;
                }

                @include respond-below(lg) {
                    h2 {
                        font-size: 1.3rem;
                    }
                }
            }

            .title {
                // font-weight: 900;
                // font-size: 7.2rem;
                // color: $cl-red;
                // font-family: "Poppins", Helvetica, sans-serif;
                // h3 {
                //     // width: 100%;
                //     display: block;
                // }
                // span {
                //     font-weight: 600;
                //     color: $cl-grey;
                // }
                margin-top: 1rem;
                margin-bottom: 3rem;
                img {
                    width: 100%;
                    height: auto;
                }
            }

            @include respond-below(lg) {
                .text-wrapper {
                    max-width: 100%;
                    margin-left: 0;
                }
            }

            .description {
                font-size: 1.8rem;
                font-weight: 500;
            }

            .primary-button {
                margin-top: 3rem;
            }
        }

        .service-images {
            // width: 60%;
            height: 100%;
            position: relative;
            @include respond-below(lg) {
                height: auto;
                margin-bottom: 2.8rem;
            }

            img {
                width: 100%;
                height: auto;
            }

            .service-images-wrapper {
                position: relative;
                width: 100%;
                height: 75%;
                top: 12.5%;
                // padding-top: 56.25%;

                @include respond-below(lg) {
                    width: 100%;
                    height: auto;
                }

                .layer-labels {
                    filter: blur(5px);
                }

                .layer-gridlines {
                    z-index: 0;
                }

                .layer-graphics {
                    z-index: 1;
                }

                .layer-images {
                    z-index: 2;
                }

                .layer-labels {
                    z-index: 3;
                }

                .layer-labels-text {
                    z-index: 4;
                }

                //     .layer-labels {
                //         position: absolute;
                //         width: 100%;
                //         height: 100%;
                //         // top: 12.5%;
                //         left: 0;
                //         z-index: 4;

                //         .label {
                //             padding: 0.8em 2em;
                //             color: white;
                //             font-weight: 700;
                //             display: inline-block;
                //             position: relative;
                //             overflow: hidden;
                //             background-color: rgba(0, 0, 0, 0.2);
                //             backdrop-filter: blur(5px);

                //             @include respond-below(lg) {
                //                 font-size: 0.8em;
                //             }

                //             // &::before {
                //             //     content: "";
                //             //     position: absolute;
                //             //     top: 0;
                //             //     width: 100%;
                //             //     height: 100%;
                //             //     left: 0;
                //             //     background-color: black;

                //             //     transform: scale(2);
                //             //     opacity: 0.2;
                //             //     z-index: -1;
                //             // }
                //         }

                //         .label-web,
                //         .label-mobile,
                //         .label-photography,
                //         .label-film {
                //             position: absolute;
                //         }

                //         .label-web {
                //             top: 33.33%;
                //             transform: translate(-210%, 600%);
                //             left: 50%;
                //         }

                //         .label-mobile {
                //             top: 20%;
                //             transform: translate(200%, 580%);
                //             left: 50%;
                //         }

                //         .label-photography {
                //             top: 38%;
                //             left: 50%;
                //             transform: translateX(-100%);
                //         }

                //         .label-film {
                //             left: 50%;
                //             bottom: 0;
                //             transform: translate(-10%, -100%);
                //         }
                //     }

                //     .layer-images {
                //         position: absolute;
                //         width: 100%;
                //         height: 100%;
                //         // top: 12.5%;
                //         left: 0;
                //         z-index: 3;

                //         .photography-img,
                //         .web-img,
                //         .mobile-img,
                //         .film-img {
                //             position: absolute;
                //             top: 0;
                //             left: 0;
                //             height: 50%;
                //             display: block;

                //             @include respond-below(lg) {
                //                 width: 45%;
                //                 height: auto;
                //             }
                //         }

                //         .web-img {
                //             top: 33.33%;
                //             transform: translateX(-150%);
                //             left: 50%;
                //             padding-right: 10px;

                //             @include respond-below(lg) {
                //                 top: 28%;
                //             }
                //         }

                //         .mobile-img {
                //             top: 20%;
                //             transform: translateX(50%);
                //             left: 50%;
                //             padding-left: 10px;
                //         }

                //         .photography-img,
                //         .film-img {
                //             left: 50%;
                //             transform: translateX(-50%);
                //         }

                //         .photography-img {
                //             padding-bottom: 10px;
                //         }

                //         .film-img {
                //             top: unset;
                //             bottom: 0;
                //             padding-top: 10px;

                //             @include respond-below(lg) {
                //                 bottom: unset;
                //                 top: 0;
                //                 transform: translate(-50%, 100%);
                //             }
                //         }
                //     }

                //     .layer-graphics {
                //         z-index: 2;
                //         position: absolute;
                //         width: 100%;
                //         height: 100%;
                //         // top: 12.5%;

                //         .square-outline,
                //         .redsquare-1,
                //         .redsquare-2,
                //         .dot-pattern {
                //             position: absolute;
                //         }

                //         .square-outline {
                //             height: 50%;
                //             width: 25%;
                //             border: 1px solid $cl-grey;
                //             // left: -25%;
                //             // top: 28%;
                //             top: 33.33%;
                //             transform: translate(-165%, -10%);
                //             left: 50%;
                //         }

                //         .dot-pattern {
                //             top: 20%;
                //             //transform: translateX(50%);
                //             transform: translate(10%, 30%);
                //             left: 50%;
                //         }

                //         .redsquare-1,
                //         .redsquare-2 {
                //             width: 9.4rem;
                //             height: 9.4rem;
                //             background-color: $cl-red;
                //         }

                //         .redsquare-1 {
                //             top: 33.33%;
                //             transform: translate(-200%, 320%);
                //             left: 50%;
                //         }

                //         .redsquare-2 {
                //             top: 20%;
                //             transform: translate(100%, -50%);
                //             left: 50%;
                //         }
                //     }

                //     .layer-gridlines {
                //         z-index: 1;
                //         position: absolute;
                //         width: 100%;
                //         height: 100%;
                //         display: flex;
                //         flex-flow: row nowrap;
                //         top: 0;
                //         // left: 25%;

                //         // background: repeating-linear-gradient(
                //         //     to right,
                //         //     transparentize(#575757, 0.9),
                //         //     transparentize(#575757, 0.9) 1px,
                //         //     $cl-cream 1px,
                //         //     $cl-cream 15%
                //         // );

                //         // .grid-column {
                //         //     position: relative;
                //         //     height: 100%;
                //         //     flex-grow: 1;

                //         //     border-right: 1px solid transparentize(#575757, 0.9);
                //         //     &:first-child {
                //         //         border-left: 1px solid transparentize(#575757, 0.9);
                //         //     }
                //         // }
                //     }
                // }
            }
        }
    }
}
</style>